<template>
  <a-modal
    ref="startWeeklyBalancing"
    title="启动周配平"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" style="width: 400px;" ref="ruleForm" :model="ruleForm" :rules="rules">
      <a-form-model-item label="计划版本" prop="mpsPlanVersion">
        <a-input v-model="ruleForm.mpsPlanVersion" disabled/>
      </a-form-model-item>
      <a-form-model-item label="参数版本" prop="mpsParamVersion">
        <!-- <a-input v-model="ruleForm.mpsParamVersion" disabled/> -->
        <global-select
          style="width: 100%"
          :value.sync="ruleForm.mpsParamVersion"
          selectType="selectSearch"
          requestApi="/scp/scpMpsPlans/getMpsParamVersion"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="version"
        />
      </a-form-model-item>
      <a-form-model-item label="月度计划" prop="mpsMonthNameVersion">
        <!-- <a-input v-model="ruleForm.mpsPlanVersion" disabled/> -->
        <global-select
          style="width: 100%"
          :value.sync="ruleForm.mpsMonthNameVersion"
          selectType="selectSearch"
          requestApi="/scp/scpMpsPlans/getMpsMonthNameVersion"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="version"
        />
      </a-form-model-item>
      <a-form-model-item label="运行时间" prop="startDate">
        <a-date-picker
          style="width: 100%"
          v-model="ruleForm.startDate"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { apiStartCalculate } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
import { genType } from '@/api/system/codeconfig'
import { ApiStartMpsPlanProcess } from '@/api/mps/basic-data/mps-option.js'

// 表单字段
export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    workshopTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      value: 1,
      timeActionType: 1,
      runIntervalTime: '', // 运行间隔时间
      runningTime: '',
      startingTime: '',
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      workshopMcNameList: [], // 车间物控(缺接口数据)
      defaultJobClassList: [],
      ruleForm: {
        mpsMonthNameVersion: '',
        mpsParamVersion: '',
        mpsPlanVersion: '',
        startDate: ''
      },
      rules: {
        mpsMonthNameVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        mpsParamVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        mpsPlanVersion: [{ required: true, message: '请输入计划版本', trigger: 'change' }],
        startDate: [{ required: true, message: '请输入计划版本', trigger: 'change' }]
      }
    }
  },
  created () {},
  methods: {
    addPamramsCode () {
      const genParams = {
        codeName: 'MPS版本'
      }
      genType(genParams).then(response => {
      if (response.code === 200) {
        this.ruleForm.mpsPlanVersion = response.data // 版本
      } else {
          this.$message.error(response.msg)
        }
      })
    },
    addPlanCode () {
      const genParams = {
        codeName: 'MPS参数版本'
      }
      genType(genParams).then(response => {
      if (response.code === 200) {
        this.ruleForm.mpsParamVersion = response.data // 版本
      } else {
          this.$message.error(response.msg)
        }
      })
    },
    addMonthPlanCode () {
      const genParams = {
        codeName: '月度计划版本'
      }
      genType(genParams).then(response => {
      if (response.code === 200) {
        this.ruleForm.mpsPlanVersion = response.data // 版本
      } else {
          this.$message.error(response.msg)
        }
      })
    },
    onChange (e) {
      console.log('radio checked', e.target.value);
    },

    handleQuery () {
      apiStartCalculate().then((response) => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    show () {
      this.visible = true
    //  this.addPlanCode()
      this.addPamramsCode()
     // this.addMonthPlanCode()
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    confirm () {
      const self = this
      this.$refs.ruleForm.validate(valid => {
      if (valid) {
       self.confirmLoading = true
       ApiStartMpsPlanProcess(this.ruleForm).then((response) => {
        self.confirmLoading = false
        if (response.code === 200) {
          self.$message.success('修改成功')
                // 关闭本组件
                self.visible = false
                // 调用外部刷新列表方法
                self.$emit('handle-success')
                // 刷新表单
             //   this.reset()
              } else {
                self.$message.error(response.msg)
              }
          }).catch(function () {
            self.confirmLoading = false
          })
          }
        }
      )
    }
  }
}
</script>

<style scoped lang="less">

  /deep/.ant-select{
    width: 100% !important;
  }
.title{
    font-weight: 650;
    font-style: normal;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.847);
    line-height: 24px;
    border-width: 0px;
}.item{
  margin: 20px 0 20px 60px;
}
</style>
